import {
  ExternalOnboardingProvider,
  ExternalOnboardingStep,
  OnboardingStep,
  OnboardingStepType,
} from '@/features/account/types/Onboarding.types';

/**
 * Returns the ID Austria external onboarding step from a `next-step` response,
 * or `undefined` when ID Austria is not offered to this user. This is the
 * availability gate that decides whether to render the "Fill with ID Austria"
 * button on the Basic Profile step (the backend hides the step e.g. when the
 * user carries the `disallow-id-austria` tag).
 */
export const getIdAustriaStep = (
  steps: OnboardingStep[] | undefined,
): ExternalOnboardingStep | undefined => {
  // Guard against an unexpected (non-array) response — e.g. an error envelope —
  // so a malformed `next-step` payload hides the button instead of crashing the
  // whole onboarding page.
  if (!Array.isArray(steps)) return undefined;

  return steps.find(
    (step): step is ExternalOnboardingStep =>
      step.type === OnboardingStepType.EXTERNAL &&
      step.provider === ExternalOnboardingProvider.ID_AUSTRIA,
  );
};
